const translations = {
    requiredErrorMessage: 'This field is required'
};

export default translations;
